import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from '../../../img/loader.gif';
// var macaddress = require('macaddress');
import Favicon from 'react-favicon';
import Login from './login';
import UpdateLoginUserPassword from './login_updatePassword';
import LogoImageViewer from '../../../components/logoImageViewer'; 

const loginComponents = {
  'login': Login,
  'updatePassword': UpdateLoginUserPassword,
};

class LoginIndex extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedComponent: 'login',
      loginUserId: null,
      errorMessage: '',
      successMessage: '',
    };
    this.redirectToLogin = this.redirectToLogin.bind(this);
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.loginResponse && nextProps.loginResponse !== this.props.loginResponse) {
      if (nextProps.loginResponse.statusCode === 205) {
        this.setState({
          selectedComponent: 'updatePassword',
          loginUserId: nextProps.loginResponse.data || null,
        });
      }
    }
    if (nextProps.updateLoginPasswordResponse && nextProps.updateLoginPasswordResponse !== this.props.updateLoginPasswordResponse) {
      if (nextProps.updateLoginPasswordResponse.statusCode === 200) {
        this.setState({
          selectedComponent: 'login',
          loginUserId: null,
        });
      }
    }

    if (nextProps.errorMessage !== this.props.errorMessage) {
      this.setState({
        errorMessage: nextProps.errorMessage,
      });
    }

    if (nextProps.successMessage !== this.props.successMessage) {
      this.setState({
        successMessage: nextProps.successMessage,
      });
    }

  }

  redirectToLogin() {
    this.setState({
      selectedComponent: 'login',
      loginUserId: null,
      successMessage: null,
      errorMessage: null,
    });
  }

  render() {
      // used for displaying different components ...
      let selectedComponent = this.state.selectedComponent;
      let CurrentComponent = loginComponents[selectedComponent];
      const loginHeaderComponent = (<h3>Login as Superadmin <i className="flaticon-building"></i></h3>);

    const { authenticatingToken } = this.props;    
    if (authenticatingToken) {
      return (
        <div className="login_bg">
          <div className="loaderwrap">
            <div className="loadermain">
              <img src={Loader} alt="" />
            </div>
          </div>
        </div>);
    }
    return (
      <div className="login_bg_WithGradient">
        <div className="login-wrapper">          
          <div className="loginlogo">
          <LogoImageViewer isLoginPage={true} logoUrl={null} businessName={null} />
          </div>
          <CurrentComponent
            {...this.props}
            successMessage={this.state.successMessage}
            errorMessage={this.state.errorMessage}
            loginUserId={this.state.loginUserId}
            redirectToLogin={this.redirectToLogin}
            loginHeaderComponent={loginHeaderComponent}/>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticatingToken: state.login.authenticatingToken,       
    errorMessage: state.login.errorMessage,
    successMessage: state.login.successMessage,
    loginResponse: state.login.loginResponse,
    updateLoginPasswordResponse: state.login.updateLoginPasswordResponse,
  };
}

export default connect(mapStateToProps, {
  
})(LoginIndex);




// WEBPACK FOOTER //
// ./src/modules/Superadmin/logins/index.js